import { PagoRealizado, PagoRealizadoDesgloseFeriaModel } from "./pagorealizado";
import { ImportesTotalesTarifa, ServiciosAdicionalesTarifaPP } from "./tarifapp";
import { ImportesGuia } from "./guia";

/**Modelo para crear un nuevo paquete de guías prepagadas */
export interface NuevoPaquetePPModel {


    /**Datos del nuevo paquete */
    Paquete: DatosPaquetePPModel;

    /**Pago realizado */
    Pago: PagoRealizadoDesgloseFeriaModel;
}

/**Datos de un nuevo paquete de guías prepagadas */
export interface DatosPaquetePPModel {
    IdCliente: number;
    IdClienteOrigen: number | null;
    IdClienteDestino: number | null;
    IdTarifaPP: number;
    CantGuias: number;
    AplicaPaquete: boolean;
    AplicaSobre: boolean;
    IdSucursal: number;
    ServiciosAdicionales: ServiciosAdicionalesTarifaPP;
    Observaciones: string;
}

/**Filtro para el query de los paquetes de PP */
export interface PaquetePPFiltro {


    IdRegistro: number | null;
    IdCliente: number | null;
    IdClienteOrigen: number | null;
    IdClienteDestino: number | null;
    IdTarifaPP: number | null;

    FechaCreacionMin: Date | string | null;
    FechaCreacionMax: Date | string | null;
    FolioGuia: string;
}

/**Un paquete comprado de guías prepagadas */
export interface PaqueteGuiaPP {

    IdRegistro: number;

    /**Folio del paquete */
    Folio: number;

    /**Fecha de creación en la que se compró el paquete */
    FechaCreacion: Date | string;

    /**Id del cliente dueño que este paquete, no necesariamente es el cliente origen o destino ya que se permite comprar paquetes libres o paquetes con cierto cliente origen o destino */
    IdCliente: number;

    /**Id del cliente origen que se tiene permitido documentar las guias o null si queda abierto para cualquier cliente origen */
    IdClienteOrigen: number | null;

    /**Id del cliente para quien se tiene permitido documentar las guias o null si queda abierto para cualquier cliente destino */
    IdClienteDestino: number | null;

    /**Id de la tarifa */
    IdTarifaPP: number;

    /**El precio por guia sin descuento al momento de crear el paquete */
    PrecioPorGuia: number;
    /**El descuento que aplico para la venta de este paquete */
    Descuento: number;

    /**Si este paquete de guias aplica para envio de paquetes */
    AplicaPaquete: boolean;
    /**Si este paquete de guías aplica para envío de sobres */
    AplicaSobre: boolean;

    /**Servicios adicionales */
    ServiciosAdicionales: ServiciosAdicionalesTarifaPP;

    FacturaContadoPagada: boolean;

    Cancelado: boolean;
}
/**DTO para un paquete de guías PP */
export interface PaquetePPDto extends PaqueteGuiaPP {
    NombreCliente: string;
    NombreClienteOrigen: string;
    NombreClienteDestino: string;
    NombreTarifaPP: string;
    CantGuiasTotal: number;
    CantGuiasGastadas: number;

    /**Importe total con guía ya con el descuento */
    ImporteTotalPorGuia: number;

    /**Importe total */
    ImporteTotal: number;

    /**Folios incluídos en este paquete PP */
    Folios: PaquetePPFolioDto[];

    /**Folio de la factura o null si no tiene factura que no este cancelada */
    FolioFactura: string;

    /**True si el paquete esta facturado */
    EstaFacturado: boolean;

    /**Es el nombre de la sucursal a la que pertenece la el paquetePP */
    NombreSucursal: string;

    Observaciones: string;

    TipoPagoFactura: TipoPagoFactura;
}

/**DTO de un folio comprado en un paquete de guías prepagadas */
export interface PaquetePPFolioDto {
    Folio: string;
    Gastado: boolean;
}

/**Filtro para la consulta de las guías prepagadas */
export interface GuiaPPFiltro {
    IdGuia?: number | null;
    IdCliente?: number | null;
    IdPaquetePP?: number | null;
    Gastada?: boolean | null;

    IdClienteOrigen?: number | null;
    IdClienteDestino?: number | null;

    AplicaPaquete?: boolean | null;
    AplicaSobre?: boolean | null;
    IdTarifaPP?: number | null;
}

export interface ItemsSelectorTarifasPP
{
    IdTarifaPP: number;
    NombreTarifaPP: string;
}

/**
* Una guía de prepago, esta es una especie de "preguia" que junto con los datos del paquete de guia, permiten documentar una guia.
* Una guía de prepago representa un descuento en la venta de la guía, que en condiciones normales este descuento sera el 100% del valor de la guía
*/
export interface GuiaPP {
    /**Folio de la guia de prepago, que también sera el folio de la guia documentada */
    IdFolioGuia: number;

    /**Paquete al que pertenece esta guía */
    IdPaqueteGuiaPP: number;

    Habilitada:boolean;
}

export interface GuiaPPDto extends GuiaPP {
    Folio: string;

    Gastada: boolean;
    Importes: ImportesGuia;
    ServiciosAdic: ServiciosAdicionalesTarifaPP;

    IdCliente: number;
    NombreCliente: string;

    IdClienteOrigen: number | null;
    NombreClienteOrigen: string;

    IdClienteDestino: number | null;
    NombreClienteDestino: string;

    AplicaPaquete: boolean;
    AplicaSobre: boolean;

    NombreTarifaPP: string;
    IdTarifaPP: number | null;

    canceladaPP : boolean;
}

/**Información del precio de un paquete de guías de prepago */
export interface PrecioPaquetePP {
    /**Importes de una guía */
    ImportesGuia: ImportesTotalesTarifa;
    /**Descuento por la cantidad de guías */
    Descuento: number;
    /**Cantidad de guías */
    CantGuias: number;
    /**Total a pagar */
    Total: number;
}

/**Contiene el Id de la documentación y en caso de que este seste facturada tiene el id de la factura donde se encuentrén facutradas las guías que se incluyen en el */
export interface PaquetePPFactura {


    /**Id de la documentación recién creada */
    IdPaquetePP: number;
    /**En caso de que se haya facturado, es el Id de la factura */
    IdFactura: number | null;
    /**Mensaje de error de facturación en caso de que no se pudiera facturar */
    ErrorFacturacion: string;
}

/**Parámetros del reporte de venta de PP */
export interface ReporteVentaPPParametros {
    FechaInicio?: Date | string | null;
    FechaFinal?: Date | string | null;
    IdSucursal?: number | null;
}

export interface ReportePaquetesPPParametros {
    IdCliente?: number | null;
    FechaInicio?: Date | string | null;
    FechaFinal?: Date | string | null;

    IdSucursal?: number | null;
    visualizar: VisualizarPaquetes;
}

export enum VisualizarPaquetes{
    Todas = 0,
    Utilizada = 1,
    NoUtilizada = 2
}

export enum TipoPagoFactura{
    Contado,
    Credito
}


// WEBPACK FOOTER //
// ./app/models/paquetepp.ts